import React from "react";
import { Badge } from "@shadcn-in-nx/ui/badge";
import { CheckCircle, Clock } from "lucide-react";
import { useTranslation } from "react-i18next";
import JsonParentTable from "../Apps/Workflow/components/JsonTable";

function ModalStepResultsTab({ isLoading, executionDetails, activeStep, onStepChange }) {
    const { t } = useTranslation();

    if (isLoading) {
        return (
            <div className="space-y-3 p-6">
                <div className="animate-pulse h-6 w-40 bg-gray-200 rounded" />
                <div className="animate-pulse h-32 bg-gray-200 rounded" />
            </div>
        );
    }

    const contextData = executionDetails?.data?.contextData;

    if (!contextData || contextData.length === 0) {
        return (
            <div className="text-center py-8 text-gray-500">
                <p>{t("monitoring.modal.noStepResults")}</p>
            </div>
        );
    }

    const activeData = contextData[activeStep];

    return (
        <div className="h-full flex flex-col">
            <div className="p-4 border-b">
                <h3 className="font-medium text-sm text-gray-500 mb-2">
                    {t("monitoring.modal.availableSteps")}
                </h3>
                <div className="flex flex-wrap gap-1">
                    {contextData.map((_, i) => (
                        <div
                            key={i}
                            onClick={() => onStepChange(i)}
                            className={`px-3 py-1 rounded-full text-xs cursor-pointer ${
                                i === activeStep
                                    ? "bg-primary text-primary-foreground"
                                    : "bg-muted hover:bg-muted/80"
                            }`}
                        >
                            {t("monitoring.modal.step")} {i + 1}
                        </div>
                    ))}
                </div>
            </div>
            <div className="flex-1 pr-6 h-full overflow-scroll">
                <div className="p-4">
                    {activeData ? (
                        <div className="space-y-4">
                            <div className="flex items-center justify-between">
                                <h4 className="font-medium text-lg">
                                    {t("monitoring.modal.step")} {activeStep + 1} {t("monitoring.modal.results")}
                                </h4>
                                <Badge className="bg-green-100 text-green-800 border-green-200">
                                    <CheckCircle className="h-3 w-3 mr-1" />
                                    {t("monitoring.status.completed")}
                                </Badge>
                            </div>
                            <JsonParentTable data={activeData} />
                        </div>
                    ) : (
                        <div className="text-center py-8 text-gray-500">
                            <Badge variant="outline" className="mb-3">
                                <Clock className="h-3 w-3 mr-1" />
                                {t("monitoring.modal.noData")}
                            </Badge>
                            <p>{t("monitoring.modal.noStepData", { step: activeStep + 1 })}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ModalStepResultsTab;
